import { Popover as PopoverA } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';

type P = {
  size?: 'small';
  stretch?: boolean;
} & ComponentProps<typeof PopoverA>;

const Popover = ({ className, classNames, size, stretch, ...rest }: P) => (
  <PopoverA
    className={cs('ui-popover-trigger', { 'ui-popover-trigger--stretch': stretch }, className)}
    classNames={
      typeof classNames === 'function'
        ? (info) => {
            const resolvedClassNames = classNames(info);

            return {
              ...resolvedClassNames,
              root: cs('ui-popover', { 'ui-popover--small': size }, resolvedClassNames?.root),
            };
          }
        : { ...classNames, root: cs('ui-popover', { 'ui-popover--small': size }, classNames?.root) }
    }
    {...rest}
  />
);

export default Popover;
